var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            {
              class: [
                _vm.processing
                  ? "al-view-card-top-color-processing"
                  : "al-view-card-top-color"
              ]
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center" } },
                        [
                          _c("v-card-title", [_vm._v("Send Shell Commands")]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _vm.processing
                            ? _c("v-progress-circular", {
                                staticClass: "mr-3",
                                attrs: {
                                  indeterminate: true,
                                  rotate: 0,
                                  size: 32,
                                  width: 4,
                                  color: "white"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.apiKey.length
            ? _c(
                "v-alert",
                { staticClass: "ma-3 pt-3", attrs: { type: "info" } },
                [
                  _vm._v(
                    "\n      An API key must be entered before any data can be loaded.\n    "
                  )
                ]
              )
            : !_vm.dataLoaded
            ? _c(
                "v-alert",
                { staticClass: "ma-3 pt-3", attrs: { type: "info" } },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { staticClass: "grow" }, [
                        _vm._v("Data must be reloaded using the new API key.")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "shrink" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "secondary", small: "" },
                              on: { click: _vm.loadData }
                            },
                            [_vm._v("Load Data")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "v-container",
                { staticClass: "pb-0 px-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-3 px-3", attrs: { align: "start" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pr-1", attrs: { cols: "6" } },
                        [
                          _c("v-select", {
                            attrs: {
                              outlined: "",
                              items: _vm.properties,
                              label: "Property",
                              "item-text": "summaryString",
                              "item-value": "id",
                              "hide-details": "",
                              rules: [_vm.rules.required]
                            },
                            model: {
                              value: _vm.selectedPropertyID,
                              callback: function($$v) {
                                _vm.selectedPropertyID = $$v
                              },
                              expression: "selectedPropertyID"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { staticClass: "pr-1", attrs: { cols: "6" } },
                        [
                          _c("v-select", {
                            attrs: {
                              outlined: "",
                              items: _vm.hubs,
                              label: "Hub",
                              "item-text": "registeredName",
                              "item-value": "id",
                              "hide-details": "",
                              rules: [_vm.rules.required]
                            },
                            model: {
                              value: _vm.selectedHubID,
                              callback: function($$v) {
                                _vm.selectedHubID = $$v
                              },
                              expression: "selectedHubID"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "pt-3 px-3", attrs: { align: "start" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-select", {
                            attrs: {
                              outlined: "",
                              label: "Shell Command",
                              items: _vm.commandOptions,
                              "item-text": "name",
                              "item-value": "command",
                              "return-object": "",
                              rules: [_vm.rules.required],
                              disabled:
                                _vm.processing || !_vm.selectedPropertyID
                            },
                            model: {
                              value: _vm.selectedCommand,
                              callback: function($$v) {
                                _vm.selectedCommand = $$v
                              },
                              expression: "selectedCommand"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              label: "New Value",
                              disabled:
                                _vm.processing ||
                                !_vm.selectedCommand ||
                                !_vm.selectedCommand.requiresValue,
                              rules:
                                !!_vm.selectedCommand &&
                                !!_vm.selectedCommand.requiresValue
                                  ? [_vm.rules.required]
                                  : []
                            },
                            model: {
                              value: _vm.commandValue,
                              callback: function($$v) {
                                _vm.commandValue = $$v
                              },
                              expression: "commandValue"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              readonly: "",
                              disabled: "",
                              value: _vm.commandText,
                              label: "Command Text"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.commandResult
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  value: _vm.commandResult,
                                  label: "Result",
                                  outlined: "",
                                  readonly: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
          _vm._v(" "),
          _vm.inlineMessage.message
            ? _c(
                "v-row",
                { staticClass: "px-3" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-alert",
                        {
                          staticClass: "mt-0 mb-3",
                          attrs: { type: _vm.inlineMessage.type }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.inlineMessage.message) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-3" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-badge",
                {
                  attrs: {
                    color: "error",
                    value: !_vm.apiKey,
                    content: "Required",
                    "offset-x": "45"
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        outlined: "",
                        disabled: _vm.processing
                      },
                      on: { click: () => (_vm.showApiKeyDialog = true) }
                    },
                    [_vm._v("\n          API Key\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "ml-4 mr-4 mb-1",
                  staticStyle: { "font-size": "1.35em" }
                },
                [_vm._v("|")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    loading: _vm.sendingCommand,
                    disabled: _vm.processing || !_vm.commandText
                  },
                  on: { click: _vm.sendCommand }
                },
                [_vm._v("\n        Send Command\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("al-api-key-dialog", {
        attrs: { show: _vm.showApiKeyDialog, apiKey: _vm.apiKey },
        on: {
          "update:show": function($event) {
            _vm.showApiKeyDialog = $event
          },
          "update:apiKey": function($event) {
            _vm.apiKey = $event
          },
          "update:api-key": function($event) {
            _vm.apiKey = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }